import { debug } from "./debug";
import { object } from "../helpers/object";

/*------------------------------------*\
  #THEME

  Gestion des switch theme

\*------------------------------------*/
class Theme {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
    this.context = null;
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    // DEFAULT EVENT
    if(debug.DEBUG) console.log('helpers/theme.js');
  };

  get = () => {
    return this.context = this.DOM_MODULE[0].getAttribute('data-js-theme');
  }

  isPro = () => (this.context || this.get) === 'pro';

  isPart = () => (this.context || this.get) === 'part';

  
}
export const theme = new Theme('[data-js-theme]'); 
document.addEventListener("DOMContentLoaded", function() {
  theme.init();
});